import * as React from "react"
import { AiOutlineInfoCircle } from "react-icons/ai";
import styled from "styled-components";
const InfoIcon = styled(AiOutlineInfoCircle)`
  font-size: ${p => p.small ? 18 : 26}px;
  font-weight: ${p => p.bold ? 900 : 500};
  cursor: pointer;
  margin: ${p => p.margin ? p.margin : 0};
  
  &:hover, &:focus{
    color: lightgray;
  }
`

const OutlineInfoIcon = ({small = false, margin, bold = false, onClick}) => {
  return (
      <InfoIcon small={small} bold={bold} margin={margin} onClick={onClick}/>
  )
}

export default OutlineInfoIcon
